import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Prompt, withRouter } from 'react-router-dom'

import { Reloadable } from 'components'
import { ArtworkView } from 'containers'
import {
  getArtworkUploads,
  getNextArtworkUpload,
  getUploadProgress
} from 'redux/reducers'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import UploadProgress from './UploadProgress'

import './index.css'

class Upload extends Component {
  constructor (props) {
    super(props)

    props.artworkUploadsInitProcessing()

    this.checkUploadCount = this.checkUploadCount.bind(this)
    this.keepOnPage = this.keepOnPage.bind(this)
  }

  componentDidMount () {
    window.addEventListener('beforeunload', this.keepOnPage)
  }

  keepOnPage (e) {
    e.returnValue = true
  }

  componentWillUnmount () {
    const { artworkUploadsStopProcessing } = this.props
    artworkUploadsStopProcessing()
    window.removeEventListener('beforeunload', this.keepOnPage)
  }

  componentWillReceiveProps () {
    this.checkUploadCount()
  }

  componentWillMount () {
    this.checkUploadCount()
  }

  checkUploadCount () {
    const { history, artworkUploads } = this.props
    if (!artworkUploads.length) {
      history.push(routes.selectFiles())
    }
  }

  render () {
    const { artworkUploads, uploadProgress } = this.props

    return (
      <div>
        <Prompt
          when={uploadProgress.uploaded !== uploadProgress.total}
          message='Are you sure you want to cancel the pending uploads?' />
        <UploadProgress status={uploadProgress} />
        { artworkUploads.map((item, index) => (
          <div key={index} className='upload-container'>
            <ArtworkView
              key={item.id}
              artworkId={item.id}
              uploadStatus={item.status}
              uploadProgress={item.progress || 0}
              isUploading
            />
          </div>
        )) }
      </div>
    )
  }
}

Upload.propTypes = {
  artworkUploads: PropTypes.array.isRequired,
  uploadProgress: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  artworkUploads: getArtworkUploads(state),
  nextArtworkUpload: getNextArtworkUpload(state),
  uploadProgress: getUploadProgress(state)
})

export default
  withRouter(connect(mapStateToProps, actions)(Reloadable(Upload)))



// WEBPACK FOOTER //
// ./src/containers/Upload/index.js